import {
    authReducer,
    hotelReducer,
    inviteReducer,
    appReducer,
    managerReducer,
    menuReducer,
    orderPlacementReducer,
    tablesReducer,
    paymentActivationReducer,
    ordersReducer,
    dashboardReducer,
    // activeOrdersReducer,
    inventoryReducer
} from '../slice';

const rootReducers = {
    app: appReducer,
    user: authReducer,
    invite: inviteReducer,
    manager: managerReducer,
    hotel: hotelReducer,
    menu: menuReducer,
    table: tablesReducer,
    orderPlacement: orderPlacementReducer,
    paymentActivation: paymentActivationReducer,
    orders: ordersReducer,
    dashboard: dashboardReducer,
    // activeOrder: activeOrdersReducer,
    inventory: inventoryReducer
};

export default rootReducers;
